import { render, staticRenderFns } from "./StoryCampaignGroup.vue?vue&type=template&id=aa4d8af4&scoped=true&"
import script from "./StoryCampaignGroup.vue?vue&type=script&lang=js&"
export * from "./StoryCampaignGroup.vue?vue&type=script&lang=js&"
import style0 from "./StoryCampaignGroup.vue?vue&type=style&index=0&id=aa4d8af4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa4d8af4",
  null
  
)

export default component.exports